import { OneTrustProvider } from '@grandvisionhq/cookie-consent'
import { createLocalRouteFormatter } from '@grandvisionhq/frk-routing'
import { createAppComponent } from '@grandvisionhq/www-next/pages/app'

import {
  getAddressConfig,
  getAuthConfig,
  getGoogleMapsConfig,
  INTL_DEFAULTS,
  intlConfigMap as intl,
} from '../configuration'
import { localRouteFormatters } from '../configuration/manifest'

import '@grandvisionhq/iris-ui/themes/dk-smarteyes.theme.css'
import '@grandvisionhq/iris-ui/normalize.css'
import '@grandvisionhq/iris-ui/reset.css'
import '@grandvisionhq/iris-ui/style.css'
import '../styles/index.scss'

const settings = {
  intl,
  routing: {
    formatters: [createLocalRouteFormatter({ formatters: localRouteFormatters })],
  },
  address: getAddressConfig(),
  auth: getAuthConfig(),
  googleMaps: getGoogleMapsConfig(),
}

const App = await createAppComponent({
  defaultLocale: INTL_DEFAULTS.locale,
  consentProvider: OneTrustProvider,
  settings,
})

export default App
